import type { ThreadMessage } from '@assistant-ui/react'

type ProposalActivityKey =
  | 'schemaAgent.workbench.preparingDiff'
  | 'schemaAgent.workbench.updating'
  | 'schemaAgent.workbench.repairing'

/** Only the current turn's latest tool can describe its live activity. Older
 * proposals must not make a subsequent plain question look like a new diff. */
export function proposalActivityKey(
  messages: readonly Pick<ThreadMessage, 'role' | 'content'>[]
): ProposalActivityKey | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i]
    if (message.role === 'user') break
    if (message.role !== 'assistant') continue
    const tool = [...message.content].reverse().find(part => part.type === 'tool-call')
    if (!tool) continue
    if (tool.toolName !== 'emit_schema_proposal') return null
    if (tool.isError) return 'schemaAgent.workbench.repairing'
    const artifact = tool.artifact
    if (typeof artifact === 'object' && artifact !== null && 'outcome' in artifact) {
      if (artifact.outcome === 'rejected') return 'schemaAgent.workbench.repairing'
      if (artifact.outcome === 'accepted' || artifact.outcome === 'recorded_with_errors')
        return 'schemaAgent.workbench.updating'
    }
    return tool.result === undefined
      ? 'schemaAgent.workbench.preparingDiff'
      : 'schemaAgent.workbench.updating'
  }
  return null
}
